import { GGSCountryController } from './../../../language/countryMapper/GGSCountryController';
import { GoodgameTextFieldManager } from './../../../textfield/manager/GoodgameTextFieldManager';
import { SimpleCommand } from './../../../commanding/SimpleCommand';

import {EnvGlobalsHandler} from "../../EnvGlobalsHandler";
import {IEnvironmentGlobals} from "../../IEnvironmentGlobals";
import {BasicController} from "../BasicController";
import {CountryInstanceMappingEvent} from "../../event/CountryInstanceMappingEvent";
import {IdleScreenEvent} from "../../event/IdleScreenEvent";
import {LanguageDataEvent} from "../../event/LanguageDataEvent";
import {BasicModel} from "../../model/BasicModel";
import {BasicLanguageFontManager} from "../../view/BasicLanguageFontManager";
import {BasicLayoutManager} from "../../view/BasicLayoutManager";
import {ConfigFilesVersionsModel} from "../../configuration/ConfigFilesVersionsModel";
import {TEXT_FIELDS_LOGGER} from "../../../../../index";

import {getLogger} from "@goodgamestudios/logger";
const logger = getLogger(TEXT_FIELDS_LOGGER + ".BasicChangeLanguageCommand");
export class BasicChangeLanguageCommand extends SimpleCommand {

    public static NAME: string = "BasicChangeLanguageCommand";

    public execute(commandVars: any = null): void {
        logger.debug(": load language XML", commandVars);

        if (BasicModel.languageData.hasEventListener(LanguageDataEvent.XML_LOAD_COMPLETE)) {
            BasicModel.languageData.removeEventListener(LanguageDataEvent.XML_LOAD_COMPLETE, this.bindFunction(this.onLanguageXMLComplete));
        }

        BasicModel.languageData.languageXMLLoaded = false;
        BasicModel.languageData.addEventListener(LanguageDataEvent.XML_LOAD_COMPLETE, this.bindFunction(this.onLanguageXMLComplete));
        this.env.currentCountryLanguageCode = GGSCountryController.instance.currentCountry.ggsLanguageCode;
        this.env.currentCountryLanguageVersion = ConfigFilesVersionsModel.instance.languageVersion(this.env.currentCountryLanguageCode);
        BasicModel.languageData.loadLanguage();
    }

    protected onLanguageXMLComplete(event: LanguageDataEvent): void {
        BasicModel.languageData.removeEventListener(LanguageDataEvent.XML_LOAD_COMPLETE, this.bindFunction(this.onLanguageXMLComplete));

        let fontManager: BasicLanguageFontManager = BasicLanguageFontManager.getInstance();
        fontManager.addEventListener(LanguageDataEvent.FONT_LOAD_COMPLETE, this.bindFunction(this.onFontLoadComplete));

        logger.debug(": onLanguageXMLComplete() -> Load font SWF");
        fontManager.loadFontsByLanguage();
    }

    protected onFontLoadComplete(event: LanguageDataEvent): void {
        let fontManager: BasicLanguageFontManager = BasicLanguageFontManager.getInstance();
        fontManager.removeEventListener(LanguageDataEvent.FONT_LOAD_COMPLETE, this.bindFunction(this.onFontLoadComplete));
        logger.debug(": onFontLoadComplete()");

        // Update texts
        GoodgameTextFieldManager.getInstance().updateTextInAllTextFields();

        BasicController.getInstance().dispatchEvent(new IdleScreenEvent(IdleScreenEvent.HIDE));
        BasicController.getInstance().dispatchEvent(new CountryInstanceMappingEvent(CountryInstanceMappingEvent.PROCESS_COMPLETE));
        // Display versions
        BasicLayoutManager.getInstance().showServerAndClientVersion();
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}

